<template>
  <div>
    <div class="grey lighten-3 mt-4">
      <div class="px-3 py-4">
        <div class="">Estimated Charges</div>
      </div>
      <v-divider></v-divider>
      <template v-if="!no_data.includes(activeSubscriptionInfo)">
        <div class="px-3 pt-4">
          <div class="">Prorated Invoice</div>
        </div>
        <div class="px-3 pt-4 text-caption">This is a preview of your prorated invoice that will be billed today.</div>
        <div class="px-3 pt-4 text-body-2">
          <v-layout class="mb-3">
            <v-flex class="pr-3">Active Users</v-flex>
            <v-flex v-if="!no_data.includes(activeSubscriptionInfo.count_users)" class="text-right"><strong>{{ activeSubscriptionInfo.count_users }}</strong></v-flex>
            <v-flex v-else class="text-right">No data</v-flex>
          </v-layout>
          <v-layout class="mb-3">
            <v-flex class="pr-3">Service Plan Name</v-flex>
            <v-flex 
              v-if="
                !no_data.includes(currentPricingPlanId) &&
                !no_data.includes(pricingPlans) &&
                Array.isArray(pricingPlans) &&
                pricingPlans.some(i => i.id === currentPricingPlanId && !no_data.includes(i.pricing_plan_name)) &&
                !no_data.includes(activeSubscriptionInfo.unit_amount)
              "
              class="text-right"
            ><strong>{{ `${pricingPlans.find(i => i.id === currentPricingPlanId).pricing_plan_name} - $${activeSubscriptionInfo.unit_amount.toFixed(2)}` }}</strong>/active staff</v-flex>
            <v-flex v-else class="text-right">No data</v-flex>
          </v-layout>
          <v-layout v-if="!no_data.includes(activeSubscriptionInfo.coupon)" class="mb-3">
            <v-flex class="pr-3">Coupon Code</v-flex>
            <v-flex class="text-right"><strong>{{ activeSubscriptionInfo.coupon }}</strong>
              <span v-if="!no_data.includes(activeSubscriptionInfo.coupon_amount) && Number(activeSubscriptionInfo.coupon_amount) > 0"> {{ `($${activeSubscriptionInfo.coupon_amount.toFixed(2)} off)` }}</span>
            </v-flex>
          </v-layout>
          <v-layout class="mb-3">
            <v-flex class="pr-3">Billing Date</v-flex>
            <v-flex class="text-right">
              <strong>{{ proratedBillingDate }}</strong>
            </v-flex>
          </v-layout>
          <v-layout class="pt-3 pb-1">
            <v-flex class="pr-3"><strong>PRORATED INVOICE SUBTOTAL</strong></v-flex>
            <v-flex class="text-right primary--text"><strong>{{`$${activeSubscriptionInfo.invoice_total.toFixed(2)}`}}</strong></v-flex>
          </v-layout>
          <v-layout class="pb-4"><span class="caption">This estimate does not include sales tax that may be applied later</span></v-layout>
        </div>
        <v-divider></v-divider>
      </template>
      <div class="px-3 pt-4">
        <div class="">New Invoice</div>
      </div>
      <div class="px-3 pt-4 text-caption">This is a preview of your invoice that will be billed on 
        {{ isSubscribed && endSubscription === null ? onlyDate(renewal_date) : newRenewalDate }}. 
        It may change if the subscription is updated.</div>
      <div class="px-3 pt-4 text-body-2">
        <v-layout class="mb-3">
          <v-flex class="pr-3">Active Users</v-flex>
          <v-flex class="text-right"><strong>{{ activeUsers }}</strong></v-flex>
        </v-layout>
        <v-layout class="mb-3">
          <v-flex class="pr-3">Service Plan Name</v-flex>
          <v-flex class="text-right"><strong>{{ `${pricingPlans.find(i => i.id === selectedPricingPlanId).pricing_plan_name} - $${pricePerStaff.toFixed(2)}` }}</strong>/active staff/month</v-flex>
        </v-layout>
        <v-layout v-if="!no_data.includes(coupon)" class="mb-3">
          <v-flex class="pr-3">Coupon Code</v-flex>
          <v-flex class="text-right">
            <strong>{{ coupon.coupon_id }}</strong>
            <span> {{ displayCoupon }}</span></v-flex>
        </v-layout>
        <v-layout class="mb-3">
          <v-flex class="pr-3">Billing Date</v-flex>
          <v-flex class="text-right">
            <strong>{{ newRenewalDate }}</strong>
          </v-flex>
        </v-layout>
        <v-layout class="pt-3 pb-1">
          <v-flex class="pr-3"><strong>NEW INVOICE TOTAL</strong></v-flex>
          <v-flex class="text-right primary--text"><strong>{{`$${pricePerMonth}`}}</strong>/month</v-flex>
        </v-layout>
        <v-layout class="pb-4"><span class="caption">This estimate does not include sales tax that may be applied later</span></v-layout>
        <!-- <div class="px-3 py-4 text-body-2">
        </div> -->
      </div>
      <!-- <v-divider></v-divider> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  name: 'EstimatedCharges',
  props: [
    'pricingPlans',
    'selectedPricingPlanId',
    'currentPricingPlanId',
    'coupon',
    'activeUsers',
    'activeSubscriptionInfo'
  ],
  data: () => ({
    no_data: [null, '', undefined, 'null']
  }),
  methods: {
    onlyDate(d = '') {
      return moment(d).format('MM[-]DD[-]YYYY')
    }
  },
  computed: {
    ...mapState({
        subscription_coupon: state => state.auth.user.subscription_coupon,
        renewal_date: state => state.auth.user.current_period_end
    }),
    ...mapGetters(["isSubscribed", "endSubscription"]),
    displayCoupon() {
      let coupon = null
      if(!this.no_data.includes(this.coupon)) {
        if(this.coupon.percent_off !== null) {
          coupon = `(${parseFloat(this.coupon.percent_off)}% off)`
        } else if (this.coupon.amount_off !== null) {
          coupon = `($${(parseFloat(this.coupon.amount_off)).toFixed(2)} off)`
        }
      }
      return coupon
    },
    pricePerStaff() {
      let price = null
      if(!this.no_data.includes(this.selectedPricingPlanId) &&
        !this.no_data.includes(this.activeUsers) &&
        !this.no_data.includes(this.pricingPlans) &&
        !this.pricingPlans.lenght > 0
      ) {
        let plan = this.pricingPlans.find(i => i.id === this.selectedPricingPlanId)
        let from = 1
        plan.tiers.forEach((tier, index) => {
          if (index !== plan.tiers.length - 1) {
            if(Number(this.activeUsers) >= from && Number(this.activeUsers) <= tier.up_to ) {
              price = tier.unit_amount / 100
            }
            from = Number(tier.up_to) + 1
          } else {
            if(Number(this.activeUsers) >= from) {
              price = tier.unit_amount / 100
            }
          }
        })
      }
      return price
    },
    pricePerMonth() {
      let price = null
      if(!this.no_data.includes(this.activeUsers) &&
        !this.no_data.includes(this.pricePerStaff)
      ) {
        price = parseFloat(this.activeUsers) * parseFloat(this.pricePerStaff)
        if(!this.no_data.includes(this.coupon)) {
          if(this.coupon.percent_off !== null) {
            price = parseFloat(price) - (parseFloat(price) * parseFloat(this.coupon.percent_off) / 100)
          } else if (this.coupon.amount_off !== null) {
            price = parseFloat(price) - parseFloat(this.coupon.amount_off)
          }
        }
      }
      return price.toFixed(2)
    },
    proratedBillingDate() {
      return moment().format('MM[-]DD[-]YYYY')
    },
    newRenewalDate() {
      return moment().add(1, 'months').format('MM[-]DD[-]YYYY')
    }
  }
}

</script>